module.exports = __webpack_public_path__ + "andrey.png";